import React from 'react';
import { Box, Container } from '@mui/material';
import AuthBrandingPanel from './AuthBrandingPanel';
import { authFormContainerSx, authFormPanelSx } from './authLightPanelTheme';
import './authPages.css';

/**
 * Desktop split auth layout: dark branding panel (left) + light form panel (right).
 * Mobile pages should render MobileAuthShell separately and not use this component.
 */
export default function AuthSplitLayout({
  brandingVariant = 'default',
  pageClassName = 'login-page',
  formPanelThemeClass = 'theme-light',
  containerWide = false,
  containerSx,
  formPanelSx,
  children,
}) {
  return (
    <Box
      className={pageClassName}
      sx={{
        display: 'flex',
        minHeight: '100vh',
        width: '100%',
        bgcolor: '#ffffff',
      }}
    >
      <AuthBrandingPanel variant={brandingVariant} />
      <Box
        className={`login-form-panel ${formPanelThemeClass}`}
        sx={{ ...authFormPanelSx, ...formPanelSx }}
      >
        <Container maxWidth="sm" sx={{ ...authFormContainerSx(containerWide), ...containerSx }}>
          {children}
        </Container>
      </Box>
    </Box>
  );
}
